<template>
    <div class="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
        <div class="relative w-[90%] max-w-md bg-white rounded-xl shadow-xl p-6 animate-fadeIn">
            <div class="flex justify-start items-center space-x-3 ">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                    class="w-10 text-coke-red">
                    <path fill-rule="evenodd"
                        d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z"
                        clip-rule="evenodd" />
                </svg>


                <h2 class="text-xl font-semibold text-red-600 ">
                    {{$t('error_msg')}}
                </h2>

            </div>
            <p class="text-gray-700 leading-relaxed">
                {{ $t(props.msg) }}
            </p>
        </div>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';
const props = defineProps({
    msg: {
        type: String,
        required: true
    }
});
</script>

<style>
@keyframes fadeIn {
    0% {
        transform: scale(0.95);
        opacity: 0;
    }

    100% {
        transform: scale(1);
        opacity: 1;
    }
}

.animate-fadeIn {
    animation: fadeIn 0.15s ease-out;
}
</style>
